import React from 'react';
import styled from '@emotion/styled';
import { isDJ } from 'utils';

export const ListWrapper = styled.ul`
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
  color: ${isDJ() ? 'black' : '#0B2374'};
  padding-left: ${props => (props.paddingLeft ? props.paddingLeft : `auto`)};
  margin-left: ${props => (props.marginLeft ? props.marginLeft : `auto`)};
  margin-left: ${props => (props.marginLeft ? props.marginLeft : `auto`)};
  margin-top: ${props => (props.marginTop ? props.marginTop : `0`)};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : `0`)};
  li::before {
    background-color: ${props => props.pointColor ?? ` ${props.pointColor}`};
    width: ${props => (props.pointSize ? props.pointSize : '0.5em')};
    height: ${props => (props.pointSize ? props.pointSize : '0.5em')};
  }
`;
export const StyledUL = props => {
  const { children, paddingLeft, marginLeft, marginTop, marginBottom, pointColor, pointSize } = props;
  return (
    <ListWrapper
      paddingLeft={paddingLeft}
      marginLeft={marginLeft}
      marginTop={marginTop}
      marginBottom={marginBottom}
      pointColor={pointColor}
      pointSize={pointSize}
    >
      {children}
    </ListWrapper>
  );
};
